<template>
    <div>
        <stickyNav v-if="enableStickyNav" />
         <div>
            <!-- shape Hero -->
            
                
                <div class="">
                    <div id="myCarousel" class="carousel carousel-fade" data-ride="carousel">
                        <b-carousel id="carousel1"
                                :interval="4000"
                                controls
                                fade>
                        <!-- Text slides with image -->
                        <b-carousel-slide class="airtime-slide">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-8 col-12">
                                        <h4 class="text-dark">PAYMENTS MADE <br>EASY</h4>
                                        <p  class="text-dark start">
                                           Start your airtime purchase for vending credit and data <br> for all networks.</p>
                                        <airtime-modal />
                                        <div class="d-md-flex mt-4">
                                            <div class="d-flex">
                                                <img src="img/theme/playstore1.png" class="img-fluid store">
                                                <img src="img/theme/appstore1.png" class="img-fluid mx-2 store">
                                            </div>
                                           <div class="d-flex">
                                                <img src="img/theme/code2.svg" class="img-fluid store">
                                           </div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-md-4 col-12 mb-5 floating pl-5" data-aos="fade-left" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                                        <img src="img/theme/airtime-hero.png" class="mx-auto" alt="slide">
                                    </div> -->
                                </div>
                                
                            </div>
                        </b-carousel-slide>
                        <b-carousel-slide class="enterprise-slide">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-7 col-12">
                                        <!-- <h4 class="text-dark">OUR B2B SERVICES</h4> -->
                                        <h3 class="display-3 text-dark">OUR B2B SERVICES
                                            <span class="text-dark display-4 py-md-2">Integration for businessess</span>
                                        </h3>
                                        <p  class="text-dark start">
                                           With our Merchant and Enterprise platforms using our
                                           well-detailed API documentation, you can integrate airtime
                                           purchase for vending credit and data for all telecomms</p>
                                        <contact-modal />
                                    </div>
                                </div>
                                
                            </div>
                        </b-carousel-slide>
                        <!-- <b-carousel-slide class="slide py-5">
                            <div class="container">
                                <div class="row row-grid justify-content-between">
                                    <div class="col-lg-8">
                                        <h3 class="display-3 text-dark">OUR B2B SERVICES
                                            <span class="text-dark">Integration for businessess</span>
                                        </h3>
                                        <p class="lead text-dark">With our Merchant and Enterprise platforms using our well-detailed API documentation,
                                            you can integrate airtime purchase for vending credit and data for all telecomms.</p>
                                        <base-button block type="primary" class="col-4 my-4">
                                            Learn more
                                        </base-button>
                                    </div>
                                    <div class="col-lg-4 col-12 my-5">
                                        <div class="transform-perspective-left">
                                            <img src="img/theme/phone.svg" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-carousel-slide> -->

                        </b-carousel>
                    </div>
                </div>
            
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg pt-5">
            <div class="container">
                <div class="text-center justify-content-center">
                    <div class="col-lg-12">
                        <h2 class="display-3 text-dark">Our Products</h2>
                        <p class="lead mb-5">Every of our products are easy to use and reliable for quality service.</p>
                    </div>
                </div>
                <div class="row justify-content-center mb-5 mx-3 mx-md-0">
                    <div class="col-lg-12">
                        <div class="row row-grid" >
                            <div class="col-lg-4 col-md-6 mt-4" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                                <card class="border-0 products-cards" hover shadow body-classes="pb-5 text-center">
                                    <!-- <icon name="ni ni-check-bold" size="lg" type="primary" shadow class="mb-4">
                                    </icon> -->
                                    <img src="img/icons/common/T7.png" alt="" height="120px" width="120px" class="mb-3">
                                    <h6 class="text-dark text-uppercase">Enterprise</h6>
                                    <p class="description mt-3">Partner with us to be a vendor, and deliver quality service to your customers</p>
                                    <router-link to="/enterprise">
                                        <base-button tag="a" href="#" type="primary" class="mt-4">
                                            Learn more
                                        </base-button>
                                    </router-link>
                                </card>
                            </div>
                            <div class="col-lg-4 col-md-6 mt-4" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                                <card class="border-0 products-cards" hover shadow body-classes="pb-5 text-center">
                                    <!-- <icon name="ni ni-istanbul" size="lg" type="primary" shadow class="mb-4">
                                    </icon> -->
                                    <img src="img/icons/common/T8.png" alt="" height="120px" width="120px" class="mb-3">
                                    <h6 class="text-dark text-uppercase">Custom Page</h6>
                                    <p class="description mt-3">Create your page on our platform with personalised service and experience.</p>
                                    <router-link to="/custom">
                                        <base-button tag="a" href="#" type="primary" class="mt-4">
                                            Learn more
                                        </base-button>
                                    </router-link>
                                </card>
                            </div>
                            <div class="col-lg-4 col-md-6 mt-4" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                                <card class="border-0 products-cards" hover shadow body-classes="pb-5 text-center">
                                    <!-- <icon name="ni ni-planet" size="lg" type="primary" shadow class="mb-4">
                                    </icon> -->
                                    <img src="img/icons/common/T2.png" alt="" height="120px" width="120px" class="mb-3">
                                    <h6 class="text-dark text-uppercase">Mobile</h6>
                                    <p class="description mt-3">We are available on both Android and iOS stores</p>
                                    <router-link to="/mobile">
                                        <base-button tag="a" href="#" type="primary" class="mt-4">
                                            Learn more
                                        </base-button>
                                    </router-link>
                                </card>
                            </div>
                            <div class="col-lg-4 col-md-6 mt-4" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                                <card class="border-0 products-cards" hover shadow body-classes="pb-5 text-center">
                                    <!-- <icon name="ni ni-check-bold" size="lg" type="primary" shadow class="mb-4">
                                    </icon> -->
                                    <img src="img/icons/common/T3.png" alt="" height="120px" width="120px" class="mb-3">
                                    <h6 class="text-dark text-uppercase">USSD</h6>
                                    <p class="description mt-3">With *347*76# you can recharge your line and get data. No internet required</p>
                                    <router-link to="/ussd">
                                        <base-button tag="a" href="#" type="primary" class="mt-4">
                                            Learn more
                                        </base-button>
                                    </router-link>
                                </card>
                            </div>
                            <div class="col-lg-4 col-md-6 mt-4" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                                <card class="border-0 products-cards" hover shadow body-classes="pb-5 text-center">
                                    <!-- <icon name="ni ni-istanbul" size="lg" type="primary" shadow class="mb-4">
                                    </icon> -->
                                    <img src="img/icons/common/T6.png" alt="" height="120px" width="120px" class="mb-3">
                                    <h6 class="text-dark text-uppercase">Unicard</h6>
                                    <p class="description mt-3">Get your unique numbers for your customers to use across all networks</p>
                                    <router-link to="/unicard">
                                        <base-button tag="a" href="#" type="primary" class="mt-4">
                                            Learn more
                                        </base-button>
                                    </router-link>
                                </card>
                            </div>
                            <div class="col-lg-4 col-md-6 mt-4" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                                <card class="border-0 products-cards" hover shadow body-classes="pb-5 text-center">
                                    <!-- <icon name="ni ni-planet" size="lg" type="primary" shadow class="mb-4">
                                    </icon> -->
                                    <img src="img/icons/common/T9.png" alt="" height="120px" width="120px" class="mb-3">
                                    <h6 class="text-dark text-uppercase">API</h6>
                                    <p class="description mt-3">Integrate our APIs into your application and develop your own solution</p>
                                    <router-link to="/api">
                                        <base-button tag="a" href="#" type="primary" class="mt-4">
                                            Learn more
                                        </base-button>
                                    </router-link>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="pb-5">
            <div class="container">
                <div class="text-center justify-content-center">
                    <div class="col-lg-12">
                        <h2 class="display-3 text-dark">Why Choose Us</h2>
                        <p class="lead mb-5">TopupBox is making transactions and payment easier and faster. 
                            With smart up to date tech, we have built a system to make all your activities seamless.</p>
                    </div>
                </div>
                <div class="row row-grid align-items-center">
                    <div class="col-md-5 order-md-2">
                        <img src="img/theme/secure.png" class="img-fluid rounded shadow-lg floating">
                    </div>
                    <div class="col-md-6 order-md-1" data-aos="fade-right" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                        <div class="pr-md-5">
                            <!-- <icon name="ni ni-settings-gear-65" class="mb-5" size="lg" type="primary" shadow
                                  rounded></icon> -->
                            <div class="mb-4">
                                <img src="img/icons/common/safe.svg" class="img-fluid">
                            </div>
                            <h3>Safe and Secure</h3>
                            <p>With our end to end secured back end, you can be rest assured your data and operations are safe.
                                Using cutting-edge technology, we have built our application to ensure outmost safety</p>
                            <ul class="list-unstyled mt-4">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="primary" circle class="mr-3" icon="ni ni-check-bold"></badge>
                                        <h6 class="mb-0">Transparent</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="primary" circle class="mr-3" icon="ni ni-check-bold"></badge>
                                        <h6 class="mb-0">Secured</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="primary" circle class="mr-3" icon="ni ni-check-bold"></badge>
                                        <h6 class="mb-0">Easy to use</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row row-grid align-items-center">
                    <div class="col-md-5">
                        <img src="img/theme/hassle-free.png" class="img-fluid rounded shadow-lg floating">
                    </div>
                    <div class="col-md-1"></div>
                    <div class="col-md-6" data-aos="fade-left" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                        <div class="pr-md-5">
                            <!-- <icon name="ni ni-settings-gear-65" class="mb-5" size="lg" type="primary" shadow
                                  rounded></icon> -->
                            <div class="mb-4">
                                <img src="img/icons/common/enterprise.svg" class="img-fluid">
                            </div>
                            <h3>Hassle Free</h3>
                            <p>Paying for your bills can be done at a go with a few clicks.
                                You shouldn't have to worry about unexplainable charges or delays. 
                                Available for all your;</p>
                            <ul class="list-unstyled mt-4">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="primary" circle class="mr-3" icon="ni ni-check-bold"></badge>
                                        <h6 class="mb-0">Airtime</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="primary" circle class="mr-3" icon="ni ni-check-bold"></badge>
                                        <h6 class="mb-0">Utility bills</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="primary" circle class="mr-3" icon="ni ni-check-bold"></badge>
                                        <h6 class="mb-0">Cable and network</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>
        <section class="section bg-light-blue">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 pr-lg-5">
                        <div class="card bg-code shadow text-white border-0 pt-4 pb-2">

                        <highlightjs langauge="js" :code="code" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-lg-5">
                            <div class="mb-4">
                                <img src="img/icons/common/access.svg" class="img-fluid">
                            </div>

                            <h3>Learn and Build</h3>
                            <p class="lead my-2">Developers' Guide</p>
                            <!-- <p>We have documented a set of developer tools that will make it easier for you to learn how to work with our APIs. 
                                These resources will help you build faster and test your applications before you deploy them to your users.</p> -->
                            <p>
                                With our help and API, you can build the next big thing and be the solution you have always been 
                                looking to or set your business on the required automation
                            </p>
                            <base-button tag="a" href="#" type="primary" class="mt-3">
                                Learn more
                            </base-button>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="values-section py-5">
            <div class="container py-5">
                <!-- <div class="d-flex px-3">
                    <div>
                        <icon name="ni ni-building" size="lg" class="bg-gradient-white" color="primary" shadow
                        ></icon>
                    </div>
                    <div class="pl-4">
                        <h4 class="display-3 text-white">Our values</h4>
                        <p class="text-white">We are the best in our field and here's why</p>
                    </div>
                </div> -->
                <div class="text-center justify-content-center">
                    <div class="col-lg-12">
                        <h2 class="display-3 text-dark">Our Values</h2>
                        <!-- <p class="lead mb-5">We live by our values</p> -->
                    </div>
                </div>
                <div class="row align-items-center mx-4 mt-5">
                    <div class="col-md-6 px-0">
                        <!-- <div class="position-relative pl-md-5">
                            <img src="img/theme/why-us.png" class="img-center img-fluid">
                        </div> -->
                        <!-- <card shadow class="shadow-lg--hover">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-bulb-61" gradient="info" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-dark">Accessibility</h5>
                                    <p>We are available 24/7 for service to both our prospective and existing customers</p>
                                </div>
                            </div>
                        </card> -->
                        <card shadow class="shadow-lg--hover values-card">
                            <div class="text-center px-3">
                                <div class="mb-3">
                                    <!-- <icon name="ni ni-bulb-61" gradient="info" color="white" shadow
                                          rounded></icon> -->
                                    <!-- <icon name="ni ni-settings" class="mb-2" size="md" type="primary" shadow rounded></icon> -->
                                    <img src="img/icons/common/frame.svg" class="img-fluid">
                                </div>
                                <div class="">
                                    <h5 class="title text-dark pt-3">Accessibility</h5>
                                    <p>We are available 24/7 for service to both our prospective and existing customers</p>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover values-card products-cards">
                            <div class="text-center px-3">
                                <div class="mb-3">
                                    <img src="img/icons/common/pen.svg" class="img-fluid">
                                </div>
                                <div class="">
                                    <h5 class="title text-dark pt-3">Reliability</h5>
                                    <p>We can easily be counted on as our team of experts combined with our up to date technology</p>
                                </div>
                            </div>
                        </card>
                    </div>
                    <div class="col-md-6 px-0">
                        <card shadow class="shadow-lg--hover values-card products-cards">
                            <div class="text-center px-3">
                                <!-- <div>
                                    <icon name="ni ni-settings" class="mb-2" size="md" type="primary" shadow rounded></icon>
                                </div> -->
                                <div class="mb-3">
                                    <img src="img/icons/common/notepad.svg" class="img-fluid">
                                </div>
                                <div class="">
                                    <h5 class="title text-dark pt-3">Credibility</h5>
                                    <p>Our credibility is always at the back of the mind everytime our services are rendered</p>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover values-card">
                            <div class="text-center px-3">
                                <div class="mb-3">
                                    <img src="img/icons/common/integrity.svg" class="img-fluid">
                                </div>
                                <div class="">
                                    <h5 class="title text-dark pt-3">Integrity</h5>
                                    <p>We keep to every of our words and prepositions. Integrity is at the heart of our service</p>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center mb-4">
                    <div class="col-lg-8">
                        <h2 class="display-3">Our Channels</h2>
                        <p class="lead text-muted">Available on all devices</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-2" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-delay="100" data-aos-duration="1000">
                            <img v-lazy="'img/theme/mobile1.svg'"
                                 class="img-center img-fluid shadow-lg-hover"
                                 style="width: 90px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Mobile App</span>
                                    <small class="h6 text-muted">Available for download on both Android and iOS stores</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-2" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-delay="300" data-aos-duration="1000">
                            <img v-lazy="'img/theme/laptop1.svg'"
                                 class="img-center img-fluid shadow-lg-hover"
                                 style="width: 90px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Web App</span>
                                    <small class="h6 text-muted">Available at <br /><b><a href="#">topupbox.com</a></b></small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-2" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-delay="500" data-aos-duration="1000">
                            <img v-lazy="'img/theme/ussd1.svg'"
                                 class="img-center img-fluid shadow-lg-hover"
                                 style="width: 90px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">USSD</span>
                                    <small class="h6 text-muted">Dial <b><a href="#">*347*76#</a></b> on your phone to begin.</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-2" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-delay="700" data-aos-duration="1000">
                            <img v-lazy="'img/theme/chatbot1.svg'"
                                 class="img-center img-fluid shadow-lg-hover"
                                 style="width: 90px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Chat Bot</span>
                                    <small class="h6 text-muted">Chat with us live on our website</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        

    </div>
</template>

<script>
import StickyNav from '../layout/StickyHeader';
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";
import AirtimeModal from './components/TopupBox/AirtimeModal.vue';
import ContactModal from './components/TopupBox/ContactModal.vue';

export default {
  name: "home",
  components: {
    BCarousel,
    BCarouselSlide,
    StickyNav,
    AirtimeModal,
    ContactModal
  },
  data() {
        return {
        enableStickyNav: null,
        code: '# import package \nimport topupbox \n \n#initialize SDK \nusername = "YOUR_USERNAME" \n \n# Initialize a service e.g. airtime \n airtime = topupbox.AIRTIME \n \nresponse = airtime.send([{ \n  beneficiary: "+2547XXXXXXXX", \n  amount: "200" \n}]) \n \nprint(response)'
        }
    },
    mounted() {
        // console.log('Index page created')
        // console.log('Sticky Nav mounted')
        window.addEventListener('scroll', this.handleNavDisplay)
    },
    // created() {},
    destroyed() {
        window.addEventListener('scroll', this.handleNavDisplay)
    },
    methods: {
        handleNavDisplay() {
        var y = window.scrollY
        if (y > 100 && !this.enableStickyNav) {
            // console.log ('Display New Menu')
            this.enableStickyNav = true
        } else if (y < 100 && this.enableStickyNav) {
            // console.log('Hide sticky Nav')
            this.enableStickyNav = false
        }
        }
    }
};
</script>
